import IconButton from "@/Components/IconButton/IconButton";
import Select from "@/Components/Select/Select";
import { useSetModal } from "@/shared/atoms/useModal";
import useId from "@/shared/hooks/useId";
import useRestaurantMaps from "@/shared/queries/restaurantMap/useRestaurantMaps";
import { RestaurantMap } from "@/shared/utils/interfaces";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Tooltip from "@/Components/Tooltip/Tooltip";

const MapEdit = ({
  editable = false,
  value = undefined,
  onChange = undefined,
  customMaps = undefined
}) => {
  const { data: maps } = useRestaurantMaps();
  const id = useId();
  const map = useMemo(() => {
    if (customMaps) {
      return customMaps?.find((map) => {
        if (value !== undefined) {
          return map.item_id === value;
        }
        return map.item_id === id;
      });
    }
    return maps?.find((map) => {
      if (value !== undefined) {
        return map.item_id === value;
      }
      return map.item_id === id;
    });
  }, [maps, id, value, customMaps]);

  const setModal = useSetModal();
  const { t } = useTranslation("", {
    keyPrefix: "maps"
  });

  const history = useHistory();

  return (
    <div className="bg-[white] rounded-[0.4rem] border-1 p-[1rem] border-grey-blue-light w-full">
      
      <div className="flex items-end gap-4 w-full">
        <Select
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 })
          }}
          menuPortalTarget={document.getElementById("root")}
          options={customMaps || maps}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.item_id}
          label={t(`current`)}
          value={map}
          onChange={(map: RestaurantMap) => {
            if (onChange) {
              return onChange(map);
            }
            return history.push(`/table/${map.item_id}`);
          }} />
        
        {editable && <Tooltip content=
        {t("edit")}><div><div className="flex">
            <IconButton onClick={() => setModal("map", map)} variants="edit" />
          </div></div></Tooltip>
        }
      </div>
    </div>);

};

export default MapEdit;